import React, { useState } from 'react';
import { formatPhone } from '../../../utils/phoneUtils';
import StepFooter from '../components/StepFooter';
import shell from '../SetupWizard.module.css';
import styles from './IdentityStep.module.css';

/**
 * Passo 2: cada campo tem um dono diferente (ver save_identity.php):
 * o nome do profissional vai para quem atende, o da clínica para a empresa
 * e o WhatsApp é o contato da clínica para os pacientes.
 * demo_consent (já marcado) não é gravado: fica em data.identity e faz o
 * passo do teste enviar sozinho o exemplo para este WhatsApp (DemoStep).
 */
function IdentityStep({ data, wizard }) {
  const [form, setForm] = useState({
    professional_name: data.identity.professional_name || '',
    company_name: data.identity.company_name || '',
    whatsapp: formatPhone(data.identity.whatsapp || ''),
    demo_consent: data.identity.demo_consent ?? true,
  });
  const fieldErrors = wizard.error?.fields || {};

  const change = (key) => (event) => setForm({ ...form, [key]: event.target.value });

  const submit = () => {
    const payload = { ...form, whatsapp: form.whatsapp.replace(/\D/g, '') };
    wizard.save('identity', payload, () => ({ ...data.identity, ...payload }));
  };

  const filled = form.professional_name.trim() && form.company_name.trim()
    && form.whatsapp.replace(/\D/g, '').length >= 10;

  const field = (key, label, hint, props = {}) => (
    <label className={shell.field}>
      <span className={shell.fieldLabel}>{label}</span>
      <input
        className={`${shell.input} ${fieldErrors[key] ? shell.inputError : ''}`}
        value={form[key]}
        onChange={change(key)}
        {...props}
      />
      {fieldErrors[key]
        ? <span className={shell.fieldError}>{fieldErrors[key]}</span>
        : <span className={shell.fieldHint}>{hint}</span>}
    </label>
  );

  return (
    <>
      <h2 className={shell.stepTitle}>Você e a clínica</h2>
      <p className={shell.stepHint}>É assim que os seus pacientes vão ver vocês nas mensagens e nos documentos.</p>

      {field('professional_name', 'Seu nome profissional', 'Como os pacientes te chamam. Ex.: Dra. Ana Souza', { maxLength: 100, autoFocus: true })}
      {field('company_name', 'Nome da clínica ou consultório', 'Se você atende com o próprio nome, pode repetir.', { maxLength: 150 })}
      {field('whatsapp', 'WhatsApp da clínica', 'Onde os pacientes falam com vocês. Com DDD.', {
        inputMode: 'tel',
        maxLength: 16,
        placeholder: '(11) 99999-9999',
        onBlur: () => setForm((current) => ({ ...current, whatsapp: formatPhone(current.whatsapp) })),
      })}

      <label className={styles.consent}>
        <input
          type="checkbox"
          className={styles.checkbox}
          checked={form.demo_consent}
          onChange={(event) => setForm({ ...form, demo_consent: event.target.checked })}
        />
        <span className={styles.consentText}>
          <span className={styles.consentTitle}>
            Quero receber neste WhatsApp um exemplo da mensagem de confirmação
          </span>
          <span className={styles.consentHint}>
            No próximo passo chega uma mensagem de teste, com botões para você responder.
          </span>
        </span>
      </label>

      <StepFooter
        error={wizard.error?.message}
        onBack={wizard.back}
        onPrimary={submit}
        disabled={!filled}
        saving={wizard.saving}
      />
    </>
  );
}

export default IdentityStep;
